// --- React & Redux
import React from "react";
import { useNavigate } from "react-router-dom";
// --- External UI Libraries
import Typography from "@dtci/spellbook/Typography";
import Button from "@dtci/spellbook/Button";
// --- Hooks & Actions
import { usePmxPricesAndDatesActions } from "tap/store/pmxPricesAndDates/usePmxPricesAndDates.js";
import { updateSearchParams } from "tap/utils/urlParams.js";
// --- Styles
import "../LicensingJobs/styles.scss";

/**
 * Recently updated PMX catalogs card on the Home dashboard.
 * @param {Object} props
 * @param {Array} props.catalogs - Display-ready catalog rows
 * @param {boolean} props.isLoading - Whether catalog data is loading
 */
export const PMXCatalogs = ({ catalogs = [], isLoading = false }) => {
  const navigate = useNavigate();
  const { updatePMXPricesAndDatesSearchForm } = usePmxPricesAndDatesActions();

  const handleViewRecord = (record) => {
    updatePMXPricesAndDatesSearchForm({
      key: "filterForm",
      data: { catalogId: String(record.catalog_id) },
    });

    updateSearchParams({ pathname: "/pmxCuratedDatesAndPrices" }, navigate, {
      catalogId: String(record.catalog_id),
    });
  };

  const renderContent = () => {
    if (isLoading && catalogs.length === 0) {
      return (
        <Typography
          variant="T20"
          style={{ color: "#666", fontStyle: "italic", padding: "4px 8px" }}
        >
          Loading recently updated PMX catalogs...
        </Typography>
      );
    }

    if (catalogs.length === 0) {
      return (
        <Typography
          variant="T20"
          style={{ color: "#666", fontStyle: "italic", padding: "4px 8px" }}
        >
          No recently updated PMX catalogs
        </Typography>
      );
    }

    return catalogs.map((item) => (
      <div
        key={item.id}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "4px 8px",
          fontSize: "16px",
        }}
      >
        <Typography variant={"T20"}>
          {`${item.catalog_id} - ${item.catalog_name === null ? "null" : item.catalog_name || ""} - ${item.formattedModifiedAt}`}
        </Typography>
        <Button
          labelText="View"
          styleType="link"
          onClick={() => handleViewRecord(item)}
        >
          VIEW
        </Button>
      </div>
    ));
  };

  return (
    <div className="home-card">
      <div className="home-card-header">Recently Updated PMX Catalogs</div>
      <div className="home-card-content">{renderContent()}</div>
    </div>
  );
};
